var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlide1BgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 669.054,
    fill: "url(#paint1_radial_7837_26927)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 668.385,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 535.244,
    fill: "url(#paint2_radial_7837_26927)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 534.574,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 401.433,
    fill: "url(#paint3_radial_7837_26927)",
    fillOpacity: 0.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 400.764,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 267.622,
    fill: "url(#paint4_radial_7837_26927)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 266.953,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.155,
    cy: 919.169,
    r: 200.716,
    fill: "url(#paint5_radial_7837_26927)",
    fillOpacity: 0.15
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 716.155,
    cy: 919.169,
    r: 200.047,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 133.811,
    fill: "url(#paint6_radial_7837_26927)",
    fillOpacity: 0.15
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 133.142,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 66.9054,
    fill: "url(#paint7_radial_7837_26927)",
    fillOpacity: 0.15
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 66.2364,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 33.4527,
    fill: "url(#paint8_radial_7837_26927)",
    fillOpacity: 0.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 724.183,
    cy: 919.169,
    r: 32.7837,
    stroke: "#6D7E8A",
    strokeOpacity: 0.2,
    strokeWidth: 1.33811
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(719.5 918.5) rotate(13.7535) scale(1201.96)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#232B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F2782",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(17.5579) scale(594.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2273"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(90) scale(589.838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282F93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(90) scale(442.379)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4E98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(90) scale(294.919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B48BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(716.155 919.169) rotate(90) scale(221.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6587CD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(90) scale(147.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A42B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86AEFC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(90) scale(73.7298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65A7F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BF3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_7837_26927",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(724.183 919.169) rotate(68.4986) scale(23.7302 22.8439)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0D3",
    stopOpacity: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1BgCircles);
export default __webpack_public_path__ + "static/media/slide_1_bg_circles.5fbf3c6d7ab504e988d21d810e21d256.svg";
export { ForwardRef as ReactComponent };